/* Feston — theme scripts. Small, dependency free. */

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    var menu = document.getElementById('MobileNav');
    if (menu) {
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return;
  }

  var thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    var main = document.getElementById('ProductMainImage');
    if (main) {
      main.src = thumb.dataset.full;
      main.alt = thumb.alt;
    }
  }
});

// Sort dropdown on collection pages
document.addEventListener('change', function (event) {
  if (event.target.matches('[data-sort]')) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }
});
